import { Text } from "@vericus/cadmus-ui";

import { QuestionFieldFragment } from "@/generated/graphql";

import { BlanksResponseForm } from "../../blanks-response-form";
import { HotspotQuestionNote } from "../constants";
import { TipContainer } from "../hotspot-position-object/hotspot-position-object-response-form.styles";
import { useHotspotTextChoiceResponseForm } from "./hooks";
import {
  CanvasWrapper,
  FormWrapper,
  QuestionWrapper,
} from "./hotspot-text-choice-response-form.styles";

interface HotspotTextChoiceResponseFormProps {
  answerBlockId: string;
  questionFields: QuestionFieldFragment[];
  isReadonly?: boolean;
}

const HotspotTextChoiceResponseForm: React.FC<
  HotspotTextChoiceResponseFormProps
> = ({ answerBlockId, questionFields, isReadonly = false }) => {
  const { wrapperRef, canvasRef, promptImage } =
    useHotspotTextChoiceResponseForm(answerBlockId);

  return (
    <QuestionWrapper>
      <TipContainer>
        <Text kind="bodyMd" color="navy500">
          {questionFields[0]?.interaction.__typename === "TextEntryInteraction"
            ? HotspotQuestionNote.TextEntryInteraction
            : HotspotQuestionNote.ChoiceInteraction}
        </Text>
      </TipContainer>
      <CanvasWrapper
        hasWiderImage={
          !!promptImage && (promptImage.width || 0) > (promptImage.height || 0)
        }
        ref={wrapperRef}
      >
        {promptImage?.url && <canvas ref={canvasRef} />}
      </CanvasWrapper>
      <FormWrapper>
        <BlanksResponseForm
          questionFields={questionFields}
          answerBlockId={answerBlockId}
          isReadonly={isReadonly}
        />
      </FormWrapper>
    </QuestionWrapper>
  );
};

export default HotspotTextChoiceResponseForm;
